import React, { useEffect, useState } from 'react';
import Layout from '../Layout';
import { Typography, Container, Box, Grid, TextField, Select, MenuItem, FormControl, InputLabel, InputAdornment, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, FormHelperText } from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';
import "../Preventive Maintenance/PreventiveMaintenance.css";
import { Button, GridLoadingSpinner } from '@tmlconnected/avant-garde-components-library';
import { useNavigate } from 'react-router-dom';
import CustomBreadcrumbs from '../Breadcrumb';
import { useDispatch, useSelector } from 'react-redux';
import { getVendorData, getAssetDataByVendorCode } from '../../ReduxStore/VendorDataSlice';
import { CreateDefaultCheckpoints, Createplan } from '../../ReduxStore/CreatePlanSlice';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const CreatePlanSupplier = () => {
    const dispatch = useDispatch();
    const breadcrumbsLinks = [
        { label: 'Home', href: '/' },
        { label: 'Physical Verification', href: '/physical-verification' },
    ];
    const navigate = useNavigate();
    const [show, setShow] = useState(true);
    const [showCreatePlan, setShowCreatePlan] = useState(false);
    const [selectedSupplier, setSelectedSupplier] = useState(null);
    const [assetList, setAssetList] = useState('');
    const [searchInput, setSearchInput] = useState('');
    const [formData, setFormData] = useState({
        frequency: "yearly",
        startDate: ""
    });
    const [open, setOpen] = useState(false);
    const { response, loading } = useSelector(state => state.vendor);

    const [formErrors, setFormErrors] = useState({});

    const validateForm = () => {
        const newErrors = {};
        const requiredFields = [
            { key: 'startDate', label: 'Start Date' },
            { key: 'frequency', label: 'Frequency' }
        ];

        requiredFields.forEach(({ key, label }) => {
            if (!formData[key]) {
                newErrors[key] = `${label} is required.`;
            }
        });

        setFormErrors(newErrors);
        return Object.keys(newErrors).length === 0; // Return true if no errors
    };


    const filteredAssets = response && response.filter((item) => {
        const searchString = searchInput.toLowerCase();

        // Ensure that the fields exist and are strings before calling toLowerCase()
        const vendorGroup = item?.vendor_group ? item.vendor_group.toLowerCase() : '';
        const vendor = item?.vendor ? item.vendor.toLowerCase() : '';
        const location = item?.location ? item.location.toLowerCase() : '';

        return (
            vendorGroup.includes(searchString) ||
            vendor.includes(searchString) ||
            location.includes(searchString)
        );
    });





    useEffect(() => {
        dispatch(getVendorData());
    }, [])


    const handleSupplierSelection = async (item) => {
        setSelectedSupplier(item);
        const action = dispatch(getAssetDataByVendorCode(item.vendor));
        const res = await action.unwrap();
        // console.log("pppppp", res);
        // if (res.response.Status === false) {
        //     handleClickOpen();
        //     console.log("hello");
        //     return
        // }
        setAssetList(res.result);
        setShow(false);
        setShowCreatePlan(true);

    }
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value
        });
    };

    const searchInputHandler = (e) => {
        setSearchInput(e.target.value);
        console.log("search Asset", searchInput);
    };

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };


    const CreatePlanHandler = async () => {

        if (!validateForm()) {
            toast.error("Please fill all required fields.");
            return; // Stop submission if validation fails
        }

        const selectedDate = new Date(formData.startDate);

        // Set the time to 12:00:00
        selectedDate.setHours(12, 0, 0, 0);

        // Extract the date components
        const day = String(selectedDate.getDate()).padStart(2, '0');
        const month = String(selectedDate.getMonth() + 1).padStart(2, '0'); // Months are zero-based
        const year = selectedDate.getFullYear();
        const hours = String(selectedDate.getHours()).padStart(2, '0');
        const minutes = String(selectedDate.getMinutes()).padStart(2, '0');
        const seconds = String(selectedDate.getSeconds()).padStart(2, '0');

        // Format the date to "DD/MM/YYYY HH:MM:SS"
        const formattedDate = `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;

        const newPlan = {
            supplier_id: selectedSupplier.id,
            start_date: formattedDate,
            frequency: formData.frequency,
        };

        console.log(newPlan);
        try {
            // const action = dispatch(Createplan({ data: newPlan, supplier_id: selectedSupplier.id }));
            const action = dispatch(Createplan(newPlan));
            const res = await action.unwrap();
            console.log("response", res);
            if (res.StatusCode === 201) {
                toast.success("Plan created Sucessfully");

                const defaultCheckpoints = [
                    {
                        plan_id: res.result.PV_plan.id,
                        check_point: "RFID Tag Present"
                    },
                    {
                        plan_id: res.result.PV_plan.id,
                        check_point: "Physical Damage"
                    }
                ]
                const action = dispatch(CreateDefaultCheckpoints(defaultCheckpoints));
                const response = await action.unwrap();
                console.log(response)
                if (response.StatusCode === 201) {
                    navigate(`/physical-verification/checklist/${res.result.PV_plan.id}/${selectedSupplier.vendor_group}`);
                }
            } else {
                toast.warning("Plan already exit for this supplier");
            }
        } catch (error) {
            toast.error(error.message || "No Logs Found!");
        }
    };


    return (
        <Layout>
            <Container>
                <Box mt={1} mb={2}>
                    <CustomBreadcrumbs links={breadcrumbsLinks} current="Create Plan" />
                </Box>

                {show &&
                    <Box mb={2}>
                        <Grid container className='row1'>
                            <Grid item xs={12} sm={5}>
                                <Typography variant="body1" style={{ fontSize: '24px', fontWeight: 300 }}>
                                    Select Supplier for Creating Plan
                                </Typography>
                            </Grid>
                            <Grid item xs={12} sm={3} className='row1'>
                                <TextField
                                    placeholder="Search Supplier"
                                    variant="outlined"
                                    size="small"
                                    onChange={searchInputHandler}
                                    InputProps={{
                                        endAdornment: (
                                            <InputAdornment position="end">
                                                <SearchIcon />
                                            </InputAdornment>
                                        ),
                                    }}
                                />
                            </Grid>
                        </Grid>
                    </Box>}
                {loading ? (
                    <Box display="flex" justifyContent="center" alignItems="center" minHeight="50vh">
                        <GridLoadingSpinner />
                    </Box>
                ) : (
                    show && filteredAssets && filteredAssets.map((item, index) => (
                        <Grid container className="assets" key={index} onClick={() => { handleSupplierSelection(item) }}>
                            <Grid item xs={12} sm={5}>
                                <h4>Supplier Name: {item.vendor_group}</h4>
                            </Grid>
                            <Grid item xs={12} sm={2}>
                                <h4>Vendor Code: {item.vendor}</h4>
                            </Grid>
                            <Grid item xs={12} sm={3}>
                                <h4>Vendor Location: {item.location}</h4>
                            </Grid>
                            <Grid item xs={12} sm={2}>
                                <h4>Total Assets: {item.asset_count}</h4>
                            </Grid>

                        </Grid>

                    )

                    ))}


                {showCreatePlan &&
                    <>
                        <Grid container spacing={3} mb={2}>
                            <Grid item xs={12}>
                                <h3>
                                    Selected Supplier: {selectedSupplier && selectedSupplier.SupplierName}
                                </h3>
                            </Grid>
                            <Grid item xs={12} sm={3}>
                                <FormControl variant="outlined" fullWidth error={!!formErrors.frequency} required>
                                    <InputLabel>Frequency</InputLabel>
                                    <Select
                                        readOnly
                                        value={formData.frequency}
                                        onChange={handleInputChange}
                                        label="Frequency"
                                        name="frequency"
                                    >
                                        <MenuItem value="weekly">Weekly</MenuItem>
                                        <MenuItem value="monthly">Monthly</MenuItem>
                                        <MenuItem value="quarterly">Quarterly</MenuItem>
                                        <MenuItem value="halfyearly">Half-Yearly</MenuItem>
                                        <MenuItem value="yearly">Yearly</MenuItem>
                                    </Select>
                                    {formErrors.frequency && (
                                        <FormHelperText>{formErrors.frequency}</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={3}>
                                <TextField
                                    label="Start Date"
                                    name="startDate"
                                    type="date"
                                    variant="outlined"
                                    fullWidth
                                    error={!!formErrors.startDate}
                                    helperText={formErrors.startDate}
                                    required
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    value={formData.startDate}
                                    onChange={handleInputChange}
                                    inputProps={{
                                        min: new Date().toISOString().split("T")[0],  // Set min attribute to today's date
                                      }}
                                />
                            </Grid>
                            <Grid item xs={12} sm={3}>
                                <Button
                                    type="submit"
                                    variant="primary"
                                    style={{ backgroundColor: '#3f51b5', color: 'white' }}
                                    onClick={() => CreatePlanHandler()}
                                >
                                    Create Plan
                                </Button>
                            </Grid>
                        </Grid>
                        <Box my={3}>
                            <Grid container className='row1'>
                                <Grid item xs={12}>
                                    <Typography variant="body1" style={{ fontSize: '24px', fontWeight: 300 }}>
                                        List of Assets for {selectedSupplier.SupplierName}
                                    </Typography>
                                </Grid>
                            </Grid>
                        </Box>
                        {assetList && assetList.map((item, index) => (
                            <Grid container className="assets" key={index} >
                                <Grid item xs={12} sm={2}>
                                    {/* <h4>Asset No: {item.asset_no} </h4> */}
                                    <h4>Asset No: {(item.asset_no)?.slice(3)}</h4>
                                </Grid>
                                <Grid item xs={12} sm={5}>
                                    <h4>Asset Description: {item.description} </h4>
                                </Grid>
                                <Grid item xs={12} sm={2}>
                                    <h4>RFID No: {item?.rfid_no || "NA"} </h4>
                                </Grid>
                                <Grid item xs={12} sm={2}>
                                    <h4>Part No: {item?.material_no || "NA"} </h4>
                                </Grid>
                            </Grid>

                        ))}
                    </>
                }
                <Dialog
                    open={open}
                    onClose={handleClose}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title">{"Plan Already Exists"}</DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description" style={{ color: "red" }}>
                            A plan is already created for this Supplier. Please select a different Supplier.
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleClose} color="primary">
                            OK
                        </Button>
                    </DialogActions>
                </Dialog>
            </Container>
            <ToastContainer />
        </Layout>
    );
};

export default CreatePlanSupplier;
